export const styles = {
  container: 'tw-flex tw-flex-row tw-gap-4 tw-h-full tw-w-full',
  listContainerFull: 'tw-flex tw-flex-col tw-w-full tw-h-full tw-min-h-0 tw-transition-all tw-duration-300 tw-ease-in-out',
  listContainerSplit: 'tw-flex tw-flex-col tw-w-1/2 tw-h-full tw-min-h-0 tw-transition-all tw-duration-300 tw-ease-in-out',
};
